import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, List, ListItem, ListItemText } from '@mui/material';

const Profile = ({ isLoggedIn }) => {
  const [userData, setUserData] = useState({
    age: null,
    healthConditions: [],
  });

  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the login page if the user is not logged in
    if (!isLoggedIn) {
      navigate('/login');
    }

    // Fetch user data from your API or use mock data
    const fetchUserData = async () => {
      const data = {
        age: 25,
        healthConditions: ['Diabetes', 'Hypertension'],
      };
      setUserData(data);
    };

    fetchUserData();
  }, [isLoggedIn, navigate]);

  const { age, healthConditions } = userData;

  if (!isLoggedIn) {
    return null;
  }

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        User Profile
      </Typography>

      <Typography variant="h6" gutterBottom>
        Age: {age}
      </Typography>

      <Typography variant="h6" gutterBottom>
        Existing Health Conditions:
      </Typography>
      <List>
        {healthConditions.map((condition, index) => (
          <ListItem key={index}>
            <ListItemText primary={condition} />
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default Profile;
